import { format } from 'date-fns';
import type { AccountListQuery } from '@/api/modules/business/accountHandle';

type Amount = number | string;

const moneyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** 金额已统一为 USD，缺失值保留占位，真实零值展示为 $0.00 */
export function formatAdAccountMoney(value?: Amount | null) {
  if (value == null || (typeof value === 'string' && !value.trim())) return '—';
  const amount = Number(value);
  return Number.isFinite(amount) ? moneyFormatter.format(amount) : '—';
}

/** 列头只跟随已搜索的消耗周期，不随筛选输入草稿变化 */
export function getAdAccountPeriodText(spendTimes?: AccountListQuery['spendTimes']) {
  return spendTimes?.beginTime && spendTimes.endTime
    ? `${spendTimes.beginTime} ~ ${spendTimes.endTime}`
    : `截至 ${format(new Date(), 'yyyy-MM-dd')}`;
}
